export const scenario = {
  addScenario: "Add scenario",
  addMappingSuccess: "Message group mapped",
  deleteMappingSuccess: "Mapping deleted",
};
